import React from "react";
import { Box } from "@chakra-ui/react";

import ConditionTitle from "../ConditionTitle";
import AndOrContainer from "../../AndOrGrouping/AndOrContainer";

const AddConditionView = () => {
  return (
    <Box p={4} height="100%" overflowY="auto">
      <ConditionTitle />
      <AndOrContainer />
    </Box>
  );
};

export default React.memo(AddConditionView);
